import {AnyAction} from "redux";
import * as _ from "lodash";
import {SET_MINI_GAME_ID} from '../../actions/action';
import {createSelector} from 'reselect';
import {getHints, getMiniGames, IMiniGame, IYear} from '../../../data/data';
import {getYearData} from '../year';


//  define selectors

export const getMiniGameID = state => state.miniGame;


/**
 * get the data for the current mini game
 */
export const hasMiniGameData = createSelector(

    [getYearData],

    (year: IYear) : boolean =>
    {
        const mini_games: IMiniGame[] = getMiniGames();

        return !! year['mini-game'];
    }
);


/**
 * get the data for the current mini game
 */
export const getMiniGameData = createSelector(

    [getMiniGameID],

    (mini_game_id: string) : IMiniGame =>
    {
        const mini_games: IMiniGame[] = getMiniGames();

        return _.find(mini_games, { id: mini_game_id });
    }
);



//  define the initial state

const initialState: string = null;


/**
 * reducer: set the current mini game ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function miniGame(state: string = initialState, action: AnyAction): string
{
    switch (action.type)
    {
        case SET_MINI_GAME_ID:
        {
            const {payload} = action;
            const {mini_game_id} = payload;

            return mini_game_id;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/mini-game/miniGame.ts